export const SESSION_TYPES = Object.freeze({
  AUTOMY: 'automy',
  PORTAL: 'portal',
  APP: 'app',
});

export const SESSION_INDEX_KEY = 'session-current';

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth-token',
  AUTH_USER: 'auth-user',
  USER_CONTEXT: 'user-context',
  TWO_FACTOR_STATE: 'auth-2FA-state',
  AUTHORITY: 'authority',
  USER_TIMEZONE: 'user-timezone',
  PORTAL_CONFIG: 'config',
  APP_CONFIG: 'config',
  AUTH_REFRESHING: 'auth-refreshing',
  AUTH_TOKEN_REFRESH: 'auth-token-refresh',
  LOGOUT_IN_PROGRESS: 'logout-in-progress',
  APP_LOGIN_CONTEXT: 'app-login-appId',
  APP_REDIRECT_AFTER_LOGIN: 'app-redirect-after-login',
  APP_AUTH_CONFIG_PREFIX: 'app-auth-config-',
  OPERATIONAL_AUTH_BLOCK: 'operational-auth-block',
  /** Short-lived Stripe round-trip handoff only — not a general restricted-token store. */
  RESTRICTED_BILLING_CHECKOUT_HANDOFF: 'restricted-billing-checkout-handoff',
};

export const MIGRATION_KEYS = [
  STORAGE_KEYS.AUTH_TOKEN,
  STORAGE_KEYS.AUTH_USER,
  STORAGE_KEYS.USER_CONTEXT,
  STORAGE_KEYS.AUTHORITY,
  STORAGE_KEYS.USER_TIMEZONE,
  STORAGE_KEYS.TWO_FACTOR_STATE,
];

// Keys that hold credentials. When a session dies these must be dropped from
// every namespace of the user (automy/portal/app), otherwise a token left in an
// unrelated namespace is later picked up as a live session by tryRestoreSession.
export const AUTH_SESSION_KEYS = [
  STORAGE_KEYS.AUTH_TOKEN,
  STORAGE_KEYS.AUTH_USER,
  STORAGE_KEYS.USER_CONTEXT,
  STORAGE_KEYS.AUTHORITY,
  STORAGE_KEYS.AUTH_REFRESHING,
  STORAGE_KEYS.AUTH_TOKEN_REFRESH,
  STORAGE_KEYS.TWO_FACTOR_STATE,
];
